/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { useCallback, useRef } from 'react'

function useDebounce<F extends (...args: any[]) => any>(fn: F, delayMs = 200): (...args: Parameters<F>) => void {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  const result = useCallback(
    (...args: Parameters<F>): void => {
      if (delayMs <= 0) return fn(...args)
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        fn(...args)
        timeoutRef.current = null
      }, delayMs)
    },
    [fn, delayMs]
  )

  return result
}

export default useDebounce
